/**
 * Messaggi della barra informativa della mainpage: i parametri 1047-1050 (uno per lingua)
 * contengono uno o piu' messaggi separati da un trattino con gli spazi intorno ("Uno - Due"),
 * anche a inizio riga come in un elenco. Il trattino attaccato ("9-18", "Wi-Fi") e la virgola
 * fanno parte del testo. Solo lookahead: il lookbehind manca in Safari prima della 16.4 (iOS 15).
 */
export function dividiMessaggiInfoBar(valore: unknown): string[] {
  if (typeof valore !== 'string') {
    return [];
  }
  return (' ' + valore + ' ').split(/\s-(?=\s)/).map(messaggio => messaggio.trim()).filter(messaggio => messaggio !== '');
}
